module.exports = __webpack_public_path__ + "static/media/bg_recommendation_01.691c12a3.png";